import {Component, EventEmitter, Input, OnInit, Output, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {WageModel} from 'app/_models/wage.model';
import {CriteriaComponent} from '../criteria/criteria.component';
import {SalaryClassComponent} from '../salary-class/salary-class.component';
import {AgencyService, ProjectPlanningService} from 'app/_services';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import { WageTranslateModel } from 'app/_models/wage-translate.model';
import { AITranslationService } from 'app/_services/ai-translation.service';

@Component({
  moduleId: module.id,
  selector: 'app-wages',
  templateUrl: `./wages.component.html`,
  styleUrls: ['./style.component.scss'],
  providers: [MessageService, ConfirmationService]
})

export class WagesComponent implements OnInit, OnChanges {

  openEditCriteriaModal = false;
  openEditSalaryClassModal = false;
  public currentLanguage = localStorage.getItem('Language');
  public activeLangTabIndex: number = 0;

  
  @ViewChild('criteriaComponent') criteriaComponent: CriteriaComponent;
  @ViewChild('salaryClassComponent') salaryClassComponent: SalaryClassComponent;
  @ViewChild('confirmPopup') confirmPopup;
  @Output() saved = new EventEmitter<any>();
  @Input() isArchived = 0;
  @Input() canEditThisProject = true;
  // JS-1871: parent passes the project's client_id on self-service so the template pickers
  // (wage / surcharge / supplement) scope to that client instead of the agency-wide list.
  @Input() scopedClientId: number | null = null;
  // JS-1920 follow-up (2026-11-02): client-only "Edit Templates" perm. Parent (project-planning)
  // flips this to false for client users on self-service without the perm; agency users keep the
  // default true so nothing changes for them.
  @Input() canEditTemplates: boolean = true;

  // JS-1871: surcharges are agency-managed and stay read-only for CLIENT users regardless of
  // Edit Wages — only agency users can add/edit them. Getter (not field) so it reflects the
  // current session without needing a manual refresh.
  get isClientUser(): boolean {
    const u = JSON.parse(localStorage.getItem('currentUser') || 'null');
    return !!(u && u.client_id);
  }

  // JS-1871: when the salary-class column is hidden for client users, shrink the row's grid
  // template by one so the remaining fields stretch instead of leaving a gap. `baseCols` is the
  // number of visible cells excluding salary_class and max_amount.
  rowGrid(baseColsWithoutSalary: number, hasMaxAmount: boolean): string {
    const cols = baseColsWithoutSalary + (hasMaxAmount ? 1 : 0) + (this.isClientUser ? 0 : 1);
    const map: { [k: number]: string } = {
      3: 'third-grid-wrapper',
      4: 'quarter-grid-wrapper',
      5: 'fifth-grid-wrapper',
      6: 'sixth-grid-wrapper',
      7: 'seventh-grid-wrapper',
      8: 'eigth-grid-wrapper',
      9: 'ninth-grid-wrapper',
    };
    return map[cols] || 'sixth-grid-wrapper';
  }
  showModal = false;
  role = null;
  bulkRoleIds = null;
  showTemplateModal = false;
  showSurchargeTemplateModal = false;

  isWageTemplateLoading = false;


  percentageSurchargeOptions = [];
  foundPercentageSurchargeOptions = [];
  fixedSurchargeOptions = [];
  foundFixedSurchargeOptions = [];

  showSupplementTemplateModal = false;
  wages: Array<WageModel>;
  surcharges: Array<WageModel>;
  onlyWages: Array<WageModel>;
  criterias = [];
  // JS-1920 (2026-10-21): surcharges are agency-managed (templates come from the agency-wide
  // pool even on self-service — see openWageTemplatesModal/'surcharge'). The CRITERIA attached
  // to a surcharge should follow the same rule, so the agency user editing a surcharge on a
  // self-service project sees the agency's criteria list, not the client-scoped one.
  surchargeCriterias = [];
  salaryClasses = [];
  templates = [];
  surchargeTemplates = [];
  supplementTemplates = [];
  editTitleModal = false;
  currentWageTranslate = new WageTranslateModel();
  currentWageIndex;
  public languages = [
    { value: "en", label: "English", labelKey: "English" },
    { value: "de", label: "Deutsch", labelKey: "German" },
    { value: "fr", label: "Français", labelKey: "French" },
    { value: "it", label: "Italiano", labelKey: "Italian" },
  ];

  isSubmitted: boolean;
  isTranslating = false;

  addSurchargeModal = false;
  selectedSurchargeType = 'percentage';

  constructor(
    private projectPlanningService: ProjectPlanningService,
    private agencyService: AgencyService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private aiTranslationService: AITranslationService) {
    this.wages = [];
    this.onlyWages = [];
  }

  ngOnInit(): void {
    this.activeLangTabIndex = this.selectedTab() || 0;

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['canEditThisProject']) {
      console.log('Wages Component - ngOnChanges canEditThisProject:', changes['canEditThisProject'].currentValue);
    }
    if (changes['isArchived']) {
      console.log('Wages Component - ngOnChanges isArchived:', changes['isArchived'].currentValue);
    }
  }

  show(role) {
    this.role = role;
    this.bulkRoleIds = null;
    this.showTemplateModal = false;

    console.log('Wages Component - canEditThisProject:', this.canEditThisProject);
    console.log('Wages Component - isArchived:', this.isArchived);

    this.loadCriterias();
    this.loadSalaryClasses();

    this.projectPlanningService.getWages(role.id).subscribe(response => {

      this.wages = [];
      this.wages = response.map((wage) => {
        let fieldTranslations;


        if(wage.field_translations) {
          fieldTranslations = JSON.parse(wage.field_translations);
          if(typeof fieldTranslations === 'string') 
          fieldTranslations = JSON.parse(fieldTranslations);
        } else {
          fieldTranslations = new WageTranslateModel();
        }
        wage.description = fieldTranslations?.description[this.currentLanguage] || fieldTranslations?.description.de || fieldTranslations?.description.en || fieldTranslations?.description.fr || fieldTranslations?.description.it || wage.description;

        if(!wage.is_suplement && !wage.is_surcharge) {
          this.onlyWages.push(new WageModel(wage.id, wage.role_id, wage.description, wage.amount, wage.max_amount, wage.currency, wage.frequency, wage.criteria_id, wage.is_suplement, wage.percentage, wage.is_surcharge, fieldTranslations, wage.is_fixed_surcharge, wage.salary_class_id));
        }
        return new WageModel(wage.id, wage.role_id, wage.description, wage.amount, wage.max_amount, wage.currency, wage.frequency, wage.criteria_id, wage.is_suplement, wage.percentage, wage.is_surcharge, fieldTranslations, wage.is_fixed_surcharge, wage.salary_class_id);
      });
    }, err => {
      this.showModal = false;
    });
    this.showModal = true;

  }

  showBulk(roleIds) {
    this.bulkRoleIds = roleIds;
    this.role = {id: null, name: null};
    this.showTemplateModal = false;

    this.loadCriterias();
    this.loadSalaryClasses();

    this.wages = [];
    this.onlyWages = [];
    this.showModal = true;
  }

  loadCriterias() {
    this.projectPlanningService.getCriterias('wage', this.scopedClientId).subscribe(response => {
      this.criterias = response.map((criteria) => {
        const translatedName = JSON.parse(criteria.field_translations).name[this.currentLanguage]
        return {id: criteria.id, name: criteria.name};
      })
    });
    // JS-1920 (2026-10-21): also load an agency-wide list (no client scope) for the surcharge
    // criteria dropdowns. When not on self-service / no scopedClientId, this duplicates
    // criterias but keeps the two bindings symmetric.
    this.projectPlanningService.getCriterias('wage', null).subscribe(response => {
      this.surchargeCriterias = response.map((criteria) => {
        return {id: criteria.id, name: criteria.name};
      })
    });
  }

  loadSalaryClasses() {
    this.projectPlanningService.getSalaryClasses().subscribe(response => {
      this.salaryClasses = response.map((salaryClass) => {
        const translatedName = JSON.parse(salaryClass.field_translations).name[this.currentLanguage]
        return {id: salaryClass.id, name: salaryClass.name};
      })
    });
  }

  close() {
    this.showModal = false;
    this.role = null;
    this.bulkRoleIds = null;
    this.wages = [];
    this.onlyWages = [];
  }

  confirmWageDelete(wageId, index) {
      this.translate.get('Are you sure you want to remove this wage').subscribe(res => {
          this.confirmationService.confirm({
              header: this.translate.instant("Confirmation"),
              message: res,
              accept: () => {
                this.remove(wageId, index);
              }
          });
      });
  }

  remove(wageId, index) {
    if (!wageId) {
      this.wages.splice(index, 1);
        this.translate.get('Wage deleted successfully!').subscribe(res => {
            this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: res});
        });

        this.onlyWages = [];
        this.wages.map((wage) => {
          if(!wage.is_suplement && !wage.is_surcharge) {
            this.onlyWages.push(new WageModel(wage.id, wage.role_id, wage.description, wage.amount, wage.max_amount, wage.currency, wage.frequency, wage.criteria_id, wage.is_suplement, wage.percentage, wage.is_surcharge, null, wage.is_fixed_surcharge, wage.salary_class_id));
          }
        });

      return;
    }
    this.projectPlanningService.deleteWage(wageId).subscribe(response => {
        this.translate.get('Wage deleted successfully!').subscribe(res => {
            this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: res});
        });
      this.wages.splice(index, 1);

      this.onlyWages = [];
      this.wages.map((wage) => {
        if(!wage.is_suplement && !wage.is_surcharge) {
          this.onlyWages.push(new WageModel(wage.id, wage.role_id, wage.description, wage.amount, wage.max_amount, wage.currency, wage.frequency, wage.criteria_id, wage.is_suplement, wage.percentage, wage.is_surcharge, null, wage.is_fixed_surcharge, wage.salary_class_id));
        }
      });

    });

  }

  addCriteria(wage, filterValue, index) {
    this.criteriaComponent.show('wage', filterValue, index);
  }

  editCriteria(criteriaId) {
    this.criteriaComponent.editCriteria(criteriaId, false);
  }

  addSalaryClass(filterValue, key, index) {
    this.salaryClassComponent.show(filterValue, key, index);
  }

  editSalaryClass(salaryClassId) {
    this.salaryClassComponent.editSalaryClass(salaryClassId, false);
  }


  addWage(description = null, amount = null, max_amount = null, currency = 'CHF', frequency = null, criteria_id = null, is_suplement = null, percentage = null, is_surcharge = null, field_translations = null, is_fixed_surcharge = false, salary_class_id = null) {
    let trs = new WageTranslateModel();
    trs.description[this.currentLanguage] = description;

    this.wages.push(new WageModel(null, this.role.id, description, amount, max_amount, currency, frequency, criteria_id, is_suplement, percentage, is_surcharge, field_translations ? JSON.parse(field_translations) : trs, is_fixed_surcharge, salary_class_id));
    if(!is_suplement && !is_surcharge) {
      this.onlyWages.push(new WageModel(null, this.role.id, description, amount, max_amount, currency, frequency, criteria_id, is_suplement, percentage, is_surcharge, field_translations ? JSON.parse(field_translations) : trs, is_fixed_surcharge, salary_class_id))
    }
  }

  addSalarySupplement() {
    this.addWage(null, null, null, 'CHF', null, null, true, null, null, null, false, null);
  }

  addSurcharge() {
    this.addWage(null, null, null, 'CHF', null, null, null, null, true, null, this.selectedSurchargeType == 'percentage' ? false : true, null);
    this.addSurchargeModal = false;
  }

  criteriaSaved(event) {
    this.projectPlanningService.getCriterias('wage', this.scopedClientId).subscribe(response => {
      this.criterias = response.map( criteria => {
        const translatedName = JSON.parse(criteria.field_translations).name[this.currentLanguage]
        return {id: criteria.id, name: criteria.name};
      });
      if (event.index !== undefined && event.index !== null) {
        this.wages[event.index].criteria_id = event.criteria_id;
      }
    });
    // JS-1920 (2026-10-21): keep the agency-wide surcharge criteria list fresh too, so a
    // newly-saved criteria shows up immediately in the surcharge dropdown.
    this.projectPlanningService.getCriterias('wage', null).subscribe(response => {
      this.surchargeCriterias = response.map( criteria => {
        return {id: criteria.id, name: criteria.name};
      });
    });
  }

  salaryClassSaved(event) {
    this.projectPlanningService.getSalaryClasses().subscribe(response => {
      this.salaryClasses = response.map( salary_class => {
        const translatedName = JSON.parse(salary_class.field_translations).name[this.currentLanguage]
        return {id: salary_class.id, name: salary_class.name};
      });
      if (event.index !== undefined && event.index !== null) { 
        this.wages[event.index].salary_class_id = event.salary_class_id;
      }
    });
  }

  onSubmit() {
    if (this.isWagesArrayValid()) {
      const params: any = {role_id: this.role.id, wages: this.wages};
      if (this.bulkRoleIds) {
        params.role_ids = this.bulkRoleIds;
      }
      this.projectPlanningService.saveWages(params)
        .subscribe(response => {
            this.translate.get('Wages saved successfully!').subscribe(res => {
                this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: res});
            });
          this.saved.emit();
          this.close();
        });
    }
  }

  isWagesArrayValid() {
    for (let i = 0; i < this.wages.length; i++) {
      if(this.wages[i].is_surcharge) {
        if (!this.wages[i].is_fixed_surcharge && (!this.wages[i].description || !this.wages[i].percentage)) {
            this.translate.get('All fields are required!').subscribe(res => {
                this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
            });
            this.wages[i].isNotFilled = true;
          return false;
        } else if (this.wages[i].is_fixed_surcharge && (!this.wages[i].description || !this.wages[i].amount || !this.wages[i].currency || !this.wages[i].frequency)){
          this.translate.get('All fields are required!').subscribe(res => {
            this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
            });
            this.wages[i].isNotFilled = true;
          return false;
        } else {
          this.wages[i].isNotFilled = false;
        }
      }  else {
        if (!this.wages[i].description || !this.wages[i].frequency || !this.wages[i].currency || !this.wages[i].amount) {
            this.translate.get('All fields are required!').subscribe(res => {
                this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
            });
            this.wages[i].isNotFilled = true;
          return false;
        } else {
          this.wages[i].isNotFilled = false;
        }
      }
    }
    return true;
  }

  loadTemplate(template) {
    const wage: WageModel = JSON.parse(template.body);
    
    if(wage.field_translations) {
      wage.field_translations = JSON.parse(wage.field_translations);
      if(!wage.field_translations.description['en'] && !wage.field_translations.description['de'] && !wage.field_translations.description['fr'] && wage.field_translations.description['it']) {
        wage.field_translations[this.currentLanguage] = wage.description !== "" && wage.description !== null ? wage.description : "Untitled";
      }
      wage.field_translations = JSON.stringify(wage.field_translations);
    }
    this.addWage(template.name, wage.amount, wage.max_amount, wage.currency, wage.frequency, wage.criteria_id, wage.is_suplement, wage.percentage , wage.is_surcharge, wage.field_translations, wage.is_fixed_surcharge, wage.salary_class_id);
  }

  saveTemplate(wage: WageModel) {

    const templateType = wage.is_surcharge ? 'surcharge' : wage.is_suplement ? 'supplement' : 'wage';
      this.translate.get('Are you sure that you want to save \'this.subject\' as a template?', {value: wage.description }).subscribe(res => {
          this.confirmationService.confirm({
              header: this.translate.instant("Confirmation"),
              message: res,
              accept: () => {
                  if ((wage.is_surcharge && wage.percentage && wage.description) || (wage.description && wage.amount && wage.currency && wage.frequency)) {
                      
                      let translations = JSON.stringify(wage.field_translations);
                      const templateBody = JSON.stringify({
                          description: wage.description, amount: wage.amount, currency: wage.currency,
                          frequency: wage.frequency, criteria_id: wage.criteria_id, percentage: wage.percentage, is_suplement: wage.is_suplement, is_surcharge: wage.is_surcharge,
                          field_translations: translations, is_fixed_surcharge: wage.is_fixed_surcharge, salary_class_id: wage.salary_class_id
                      });
                      // JS-1871: surcharges stay agency-wide even on self-service.
                      const templateClientId = templateType === 'surcharge' ? undefined : (this.scopedClientId || undefined);
                      this.projectPlanningService.saveTemplate({
                          name: wage.description, type: templateType,
                          client_id: templateClientId,
                          body: templateBody
                      }).subscribe(response => {
                          switch (response.status) {
                              case 'success':
                                  this.templates = response.templates;
                                  break;
                              case 'exists':
                                  // JS-1871 Andrea point 13: overwrite instead of silently no-op'ing.
                                  // Defer so the outer "save as template?" confirm has fully closed —
                                  // PrimeNG reuses one p-confirmDialog instance, so opening a nested
                                  // confirm synchronously makes the second one flash + dismiss.
                                  this.translate.get('Template with the name {value} already exists. Do you want to overwrite it?', { value: wage.description }).subscribe(msg => {
                                      // 500ms matches the role-template overwrite flow in
                                      // project-planning.component.ts (~line 2234). PrimeNG's outer
                                      // confirm teardown runs long enough that a 0ms defer still
                                      // dismisses this one before the user sees it.
                                      setTimeout(() => this.confirmationService.confirm({
                                          header: this.translate.instant('Confirmation'),
                                          message: msg,
                                          accept: () => {
                                              this.agencyService.updateTemplate(response.template_id, {
                                                  name: wage.description,
                                                  type: templateType,
                                                  body: templateBody,
                                                  client_id: templateClientId
                                              }).subscribe(updated => {
                                                  if (updated && updated.templates) {
                                                      this.templates = updated.templates;
                                                  }
                                                  this.translate.get('Template updated successfully').subscribe(ok => {
                                                      this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: ok});
                                                  });
                                              });
                                          }
                                      }), 500);
                                  });
                                  break;
                              case 'error':
                                  this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: response.message});
                                  break;
                          }
                      });
                  } else {
                      this.translate.get('Please fill the row before you save it as template').subscribe(resp => {
                          this.messageService.add({
                              severity: 'error',
                              summary: this.translate.instant('Error!'),
                              detail: resp
                          });
                      });
                  }
              }
          });
      });
  }

  saveCriterias() {
  
  }

  saveSalaryClasses() {
  
  }

  selectedTab() {
    if (this.currentLanguage === "en") {
      return 0;
    } else if (this.currentLanguage === "de") {
      return 1;
    } else if (this.currentLanguage === "fr") {
      return 2;
    } else if (this.currentLanguage === "it") {
      return 3;
    }
  }

  openWageTitle(index, wage) {
    this.editTitleModal = true;
    this.currentWageTranslate = wage.field_translations;
    this.currentWageIndex = index
  }

  storeWageTranslates() {
    if(!this.currentWageTranslate.description['en'] && !this.currentWageTranslate.description['de'] && !this.currentWageTranslate.description['fr'] && !this.currentWageTranslate.description['it']) {
      this.messageService.add({
        severity: 'error', 
        summary: this.translate.instant('Error!'), 
        detail: this.translate.instant('Please enter title on at least one language.')});
      return;
    }
    this.wages[this.currentWageIndex].description = this.currentWageTranslate.description[this.currentLanguage] || this.currentWageTranslate.description.de || this.currentWageTranslate.description.en || this.currentWageTranslate.description.fr || this.currentWageTranslate.description.it
    this.wages[this.currentWageIndex].field_translations = this.currentWageTranslate;
    this.editTitleModal = false;
  }


  openSurchargesTemplatesModal() {
    this.showSurchargeTemplateModal = true;
    this.openWageTemplatesModal('surcharge');
  }

  searchPercentageSurcharge(value) {
    this.foundPercentageSurchargeOptions = this.percentageSurchargeOptions.filter(function(element) {
        return element.name.toLowerCase().includes(value.toLowerCase());
    });
  }

  searchFixedSurcharge(value) {
    this.foundFixedSurchargeOptions = this.fixedSurchargeOptions.filter(function(element) {
        return element.name.toLowerCase().includes(value.toLowerCase());
    });
  }

  hasOtherLangContent(targetLang: string): boolean {
    const langs = ['en', 'de', 'fr', 'it'];
    return langs.some(l => l !== targetLang && !!(this.currentWageTranslate && this.currentWageTranslate.description[l] && this.currentWageTranslate.description[l].trim()));
  }

  translateToLang(targetLang: string) {
    const langs = ['en', 'de', 'fr', 'it'];
    let sourceText = '';
    let sourceLang = '';
    for (const lang of langs) {
      if (lang !== targetLang && this.currentWageTranslate.description[lang]?.trim()) {
        sourceText = this.currentWageTranslate.description[lang];
        sourceLang = lang;
        break;
      }
    }

    this.isTranslating = true;
    this.aiTranslationService.translate(sourceText, sourceLang, targetLang).subscribe(
      response => {
        this.currentWageTranslate.description[targetLang] = response.translated_text;
        this.isTranslating = false;
      },
      () => { this.isTranslating = false; }
    );
  }

  openWageTemplatesModal(type){
    this.isWageTemplateLoading = true;
    switch(type){
      case "wage":
        this.projectPlanningService.loadTemplates('wage', this.scopedClientId).subscribe(response => {
          this.templates = [];
    
          for(let i = 0; i < response.templates.length; i++) {
            if(JSON.parse(response.templates[i].body).is_suplement) {} else {
              this.templates.push(response.templates[i])
            }
          }
          this.isWageTemplateLoading = false;
        });
        break;
      case "surcharge":
        // JS-1871: surcharges are agency-managed — always load the agency-wide surcharge
        // templates, never the client-scoped ones (client users can't create surcharges).
        this.projectPlanningService.loadTemplates('surcharge').subscribe(response => {
          this.surchargeTemplates = response.templates;
          this.percentageSurchargeOptions = [];
          this.fixedSurchargeOptions = [];

          this.surchargeTemplates.forEach(template => {
            if (template.is_fixed_surcharge) {
              this.fixedSurchargeOptions.push(template);
            } else {
              this.percentageSurchargeOptions.push(template);
            }
          });
          
          this.foundPercentageSurchargeOptions = this.percentageSurchargeOptions;
          this.foundFixedSurchargeOptions = this.fixedSurchargeOptions;
          this.isWageTemplateLoading = false;
        });
        break;
      case "supplement":
        this.projectPlanningService.loadTemplates('supplement', this.scopedClientId).subscribe(response => {
          this.supplementTemplates = response.templates;
          this.isWageTemplateLoading = false;
        });
        break;
      }
  }

}